<template>
  <div class="tooltip-main" @mousemove="mouseState($event, true)" @mouseleave="mouseState(false)">
    <div v-if="showTooltip" class="tooltip-object" :class="`tooltip-${position}`" :style="{ top: `${posY}px`, left: `${posX}px`, minWidth: `${minWidth}px`, maxWidth: `${maxWidth}px`}">
      <slot name="tooltip">
        <div class="tooltip-arrow" :class="`arrow-${position}`"></div>
        <slot name="tooltipText">{{ tooltipText }}</slot>
      </slot>
    </div>
    <slot>
      <img :src="icon" :height="iconSize" :width="iconSize">
    </slot>
    <img v-if="$slots.default && showIndicator" class="tooltip-icon" :style="{ opacity: showTooltip ? '1' : '0.3' }"
      src="https://dsmapi.logistics.systems/dsm6gIcons/TooltipInfo.png" height="20" width="20">
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      showTooltip: false,
      posX: 0,
      posY: 0
    }
  },
  props: {
    icon: { type: String, default: 'https://dsmapi.logistics.systems/dsm6gIcons/TooltipInfo.png' }, // This is the default icon used if the slot is empty
    iconSize: { type: Number, default: 20 }, // The size of the icon
    position: { type: String, default: 'bottom' }, // The position of the tooltip, available positions: [top, bottom, left, right]
    minWidth: { type: Number, default: 150 }, // Set the minimum width of the tooltip
    maxWidth: { type: Number, default: 500 }, // Set the maximum width of the tooltip
    tooltipText: { type: String, default: 'Tooltip not set' }, // Set the text of the tooltip
    xOffset: { type: Number, default: 0 }, // Horizontal offset of the tooltip
    yOffset: { type: Number, default: 0 }, // Vertical offset of the tooltip
    showIndicator: { type: Boolean, default: true },
  },
  methods: {
    mouseState: function(e, enter) {
      if (e) {
        this.posX = e.offsetX > 0 ? e.offsetX : 0;
        this.posX += this.xOffset;
        this.posY = e.offsetY > 0 ? e.offsetY : 0;
        this.posY += this.yOffset;
      }
      this.showTooltip = enter;
    }
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.tooltip-main {
  height: fit-content;
  width: fit-content;
  position: relative;
  cursor: default;

  > .tooltip-object {
    position: absolute;
    background-color: rgb(70, 70, 70);
    color: white;
    padding: 5px;
    pointer-events: none;
    z-index: 100;
    border-radius: 5px;
    white-space: pre-wrap;

    > .tooltip-arrow {
      position: absolute;
      border-width: 0px 7px 7px 7px;
      border-style: solid;
      border-color: transparent transparent rgb(70, 70, 70) transparent;
    }

    > .arrow-bottom {
      bottom: 100%;
      left: 5px;
    }

    > .arrow-top {
      top: 100%;
      left: 5px;
      transform: rotate(180deg);
    }
    
    > .arrow-right {
      top: 10px;
      right: calc(100% - 4px);
      transform: rotate(270deg);
    }
    
    > .arrow-left {
      top: 10px;
      left: calc(100% - 4px);
      transform: rotate(90deg);
    }
  }

  > .tooltip-bottom {
    transform: translate(-10px, 10px);
  }

  > .tooltip-top {
    transform: translate(-10px, calc(-100% - 5px));
  }

  > .tooltip-right {
    transform: translate(10px, -10px);
  }

  > .tooltip-left {
    transform: translate(calc(-100% - 6px), -10px);
  }

  > .tooltip-icon {
    position: absolute;
    top: 0;
    right: 0;
    pointer-events: none;
    transition: 0.3s;
    opacity: 0.3;
  }
}
</style>